<template>
  <div class="main-nav-other" v-if="renderData.otherEntrance.length">
    <template v-for="(item, index) in renderData.otherEntrance" :key="index">
      <div
        class="main-nav-other-item pointer"
        @click="
          () => {
            openOther(item);
          }
        "
      >
        <i
          :style="{
            background: `url(${item.ico})`,
            'background-size': '100% 100%',
          }"
        ></i>
      </div>
    </template>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import { $$language, $$t } from "@/i18n/i18n.js";
import useUserDataStore from "@/store/userDataStore";

import InstagramIco from "@/assets/img/instagram-ico-3x.png";
import TwitterIco from "@/assets/img/twitter-ico-3x.png";
import TiktokIco from "@/assets/img/tiktok-ico-3x.png";
import YoutubeIco from "@/assets/img/youtube-ico-3x.png";
import RedditIco from "@/assets/img/reddit-ico-3x.png";
import DiscordIco from "@/assets/img/discord-ico-3x.png";

import DouyingIco from "@/assets/img/douying-ico-3x.png";
import KuaishouIco from "@/assets/img/kuaishou-ico-3x.png";
import BzhanIco from "@/assets/img/bzhan-ico-3x.png";
import GlobalConfig from "@/config/config.js";

const globalProperties = getCurrentInstance()?.appContext.config.globalProperties;

const userDataStore = useUserDataStore();
const props = defineProps({});
const emits = defineEmits([]);
const stateData = {
  cnEntranceMap: [
    {
      lang: "cn",
      label: "抖音：",
      ico: DouyingIco,
      url: "https://www.douyin.com/user/MS4wLjABAAAANveXe_WjD6nKr_z8GeezeL5ihLRhX11yS0TbD91_ZiCK6Ckf5-eEPEXiMHk3QVbB",
    },
    {
      lang: "cn",
      label: "快手：",
      ico: KuaishouIco,
      url: "https://v.kuaishou.com/Fc8yMA",
    },
    {
      lang: "cn",
      label: "b站：",
      ico: BzhanIco,
      url: "https://space.bilibili.com/3546702594181285",
    },
  ],
  otherEntranceMap: [
    // {
    //   lang: "en",
    //   label: "Instagram：",
    //   ico: InstagramIco,
    //   url: "https://www.instagram.com/mureka.ai",
    // },
    {
      lang: "en",
      label: "twitter",
      ico: TwitterIco,
      url: "https://x.com/Mureka_AI",
    },
    // {
    //   lang: "en",
    //   label: "Tiktok",
    //   ico: TiktokIco,
    //   url: "https://www.tiktok.com/@mureka.ai",
    // },
    {
      lang: "en",
      label: "youtube",
      ico: YoutubeIco,
      url: "https://youtube.com/@mureka_ai",
    },
    // {
    //   label: "Reddit",
    //   ico: RedditIco,
    //   url: "https://www.reddit.com/r/mureka/",
    // },
    {
      lang: "en",
      label: "discord",
      ico: DiscordIco,
      url: "https://discord.gg/nwu9ANqAf5",
    },
  ],
};
const renderData = reactive({
  otherEntrance: GlobalConfig.appname === "MurekaCn" || $$language() == "cn" ? stateData.cnEntranceMap : stateData.otherEntranceMap,
});

const openOther = (item) => {
  globalProperties.logClickEvent(`catalog_${item.label}`);
  window.open(item.url, "_blank");
};

watch(
  () => userDataStore.appLanguage,
  (newVal) => {
    nextTick().then(() => {
      renderData.otherEntrance = GlobalConfig.appname === "MurekaCn" || $$language() == "cn" ? stateData.cnEntranceMap : stateData.otherEntranceMap;
    });
  }
);

onMounted(() => {});
</script>
<style lang="scss">
.main-nav-other {
  height: 60px;
  padding: 0 10px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
  .main-nav-other-item {
    border-radius: 20px;
    padding: 5px;
    i {
      opacity: 0.6;
      display: block;
      height: 24px;
      width: 24px;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
      i {
        opacity: 1;
      }
    }
  }
}
</style>
